import { CurrencyPipe } from '@angular/common';
import { Component, computed, inject, input, InputSignal, Signal, signal } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { SignalsStoreService } from '../../shared/signals-store.service';

@Component({
  selector: 'app-order-slider',
  imports: [CurrencyPipe, MatProgressBar],
  templateUrl: './order-slider.component.html',
  styleUrl: './order-slider.component.scss'
})
export class OrderSliderComponent {

  private signalsStoreService = inject(SignalsStoreService);

  hasMinOrder: InputSignal<boolean> = input.required();
  orderDeliveryFee: InputSignal<number> = input.required();
  minOrder: InputSignal<number> = input.required();
  minOrderDiffForFreeDelivery: InputSignal<number> = input.required();
  // Material's `accent` maps to WH's $primary-palette (green #82C341). Default
  // (`''`) resolves to Material's primary, which is wired to $secondary-palette
  // (orange). We keep orange while ramping up and flip to green once the
  // minimum is met.
  progressBarColor: Signal<string> = computed(() => this.hasMinOrder() ? 'accent' : '');
  percentMinSpend: InputSignal<number> = input.required();
  currentSliderInfo: InputSignal<any> = input.required();
  enableFreeDeliveryThreshold: InputSignal<boolean> = input.required();
  hasDeliveryFeeRange: InputSignal<boolean> = input.required();
  validationMethod: InputSignal<'before_discounts' | 'after_discounts'> = input.required();
  hasPricelistDiscount: InputSignal<boolean> = input.required();
  qualifyingSubtotal: InputSignal<number> = input.required();
  isPickup: Signal<boolean> = computed(() => this.signalsStoreService.isAddressRequired() === false);

  // Show the explanatory copy only when the minimum is validated on public prices
  // while the shopper is looking at a discounted (member-priced) cart. Otherwise
  // the classic "you haven't reached the minimum" message is accurate.
  showBeforeDiscountsExplanation: Signal<boolean> = computed(
    () => this.validationMethod() === 'before_discounts' && this.hasPricelistDiscount()
  );

}
